"use strict";

define('uikit/helper/dom',['jquery'], function ($) {
  function createCaretPlacer(atStart) {
    return function (el) {
      el.focus();
      if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(atStart);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(atStart);
        textRange.select();
      }
    };
  }
  var DOM = {
    placeCaretAtStart: createCaretPlacer(true),
    placeCaretAtEnd: createCaretPlacer(false),
    clearSelection: function clearSelection() {
      var selection = window.getSelection();
      if (selection.rangeCount > 0) {
        selection.getRangeAt(0).startContainer.parentNode.blur();
      }
      selection.removeAllRanges();
    },
    cursorPosition: function cursorPosition() {
      var selection = document.getSelection(),
        caretRange = {};
      if (selection.rangeCount > 0) {
        caretRange = selection.getRangeAt(0);
      }
      return {
        caretStart: caretRange.startOffset,
        caretEnd: caretRange.endOffset,
        selectionLength: caretRange.endOffset - caretRange.startOffset
      };
    },
    focusable: function focusable(parentEl) {
      var parent = $(parentEl || document.body);
      return parent.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(':visible').filter(function (index, el) {
        return $(el).css('visibility') == 'visible';
      });
    },
    stickFocusWithinElement: function stickFocusWithinElement(ev, container) {
      var target = ev.target,
        focusableChildren = null,
        focusableNumOfChildren = null;
      if (ev.keyCode == 9) {
        focusableChildren = this.focusable(container);
        focusableNumOfChildren = focusableChildren.length;
        if (!focusableNumOfChildren) {
          target.blur();
          ev.preventDefault();
          return;
        }
        if (ev.shiftKey) {
          if (focusableChildren.get(0) == target || !container.contains(target)) {
            ev.preventDefault();
            focusableChildren.eq(focusableNumOfChildren - 1).focus();
          }
        } else {
          if (focusableChildren.get(focusableNumOfChildren - 1) == target || !container.contains(target)) {
            ev.preventDefault();
            focusableChildren.eq(0).focus();
          }
        }
      }
    }
  };
  return DOM;
});

